import { render, staticRenderFns } from "./StakingNFTPool.vue?vue&type=template&id=8a90fd0a&scoped=true&"
import script from "./StakingNFTPool.vue?vue&type=script&lang=js&"
export * from "./StakingNFTPool.vue?vue&type=script&lang=js&"
import style0 from "./StakingNFTPool.vue?vue&type=style&index=0&id=8a90fd0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a90fd0a",
  null
  
)

export default component.exports